import { FC } from 'react';
import { twMerge } from 'tailwind-merge';
import { useCampaignsValues } from '../context';
import { SelectAudienceStepSummary } from './SelectAudienceStepSummary';
import { ConnectAudienceStepSummary } from './ConnectAudienceStepSummary';
import { DataSourceStepSummary } from './DataSourceStepSummary';
import { DestinationStepSummary } from './DestinationStepSummary';
import { NewCampaignStepSummary } from './NewCampaignStepSummary';

type CampaignSummarySectionProps = {
  className?: string;
};

export type CampaignStepSummaryProps = {
  isStepCompleted: boolean;
};

export const CampaignSummarySection: FC<CampaignSummarySectionProps> = ({ className }) => {
  const { currentStep, completedSteps } = useCampaignsValues();

  return (
    <section
      id='campaign-summary-section'
      data-active={currentStep.id !== 'CreateNewCampaign'}
      className={twMerge(
        'sticky left-0 z-[19] w-[16.875rem] shrink-0 bg-white-100 px-4 pb-5 pt-16 flex flex-col items-center overflow-y-auto overflow-x-hidden',
        'transition-discrete motion-safe:transition-[width,opacity,padding,display] motion-reduce:transition-none motion-safe:duration-500',
        'starting:w-0 starting:opacity-0 starting:px-0',
        'data-[active=false]:w-0 data-[active=false]:hidden data-[active=false]:opacity-0 data-[active=false]:px-0',
        className
      )}
    >
      <NewCampaignStepSummary isStepCompleted={completedSteps.some((cs) => cs === 'CreateNewCampaign')} />
      <DataSourceStepSummary isStepCompleted={completedSteps.some((cs) => cs === 'ImportDataSource')} />
      <DestinationStepSummary isStepCompleted={completedSteps.some((cs) => cs === 'ChooseDestination')} />
      <SelectAudienceStepSummary isStepCompleted={completedSteps.some((cs) => cs === 'SelectAudience')} />
      <ConnectAudienceStepSummary />
    </section>
  );
};
